module.exports = __webpack_public_path__ + "static/img/Frame_02.4b81203e.svg";